import { render, staticRenderFns } from "./addusdt.vue?vue&type=template&id=27dd4ede&scoped=true&"
import script from "./addusdt.vue?vue&type=script&lang=js&"
export * from "./addusdt.vue?vue&type=script&lang=js&"
import style0 from "./addusdt.vue?vue&type=style&index=0&id=27dd4ede&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd4ede",
  null
  
)

export default component.exports